import { NAVIGATION_KEYS } from "../../src/components/Layout/NavBar/types"
import { TransactionType } from "../../src/domain/ethereum/Models/Transaction"

export default {
  navigation: {
    [NAVIGATION_KEYS.POAPS]: {
      title: "POAPs",
      description: "View your POAPs and manage your collection",
    },
    [NAVIGATION_KEYS.WALLET]: {
      title: "Wallet",
      description: "View your liquidity positions both in wallet and in contracts",
    },
    [NAVIGATION_KEYS.SETTINGS]: {
      title: "Settings",
      description: "Select Language, Currency and Light / Dark Mode",
    },
  },
  back: "Back",
  connect: "Connect",
  connectWallet: "Connect your wallet",
  contractAdress: "Contract Address",
  copy: "Copy",
  copied: "Copied",
  clean: "Clean",
  error: "Error",
  settings: {
    title: "Settings",
    languages: {
      es: "Spanish",
      en: "English",
    },
    mode: {
      light: "Light",
      dark: "Dark",
    },
  },
  settingsMenu: "Settings",
  settingsDescription: "Select Language, Currency and Light / Dark Mode",
  docs: "Docs",
  docsDescription: "Access our Whitepaper to understand the protocol in depth",
  wallet: "Wallet",
  walletDescription: "View your liquidity positions both in wallet and in contracts",
  walletMobileDescription: "View your positions in all DEX tokens",
  walletAdd: "Add to wallet",
  yourAccount: "Your account",
  myHumanWallet: "My HumanWallet",
  timeUnits: {
    second: "second",
    seconds: "seconds",
    minute: "minute",
    minutes: "minutes",
    hour: "hour",
    hours: "hours",
    day: "day",
    days: "days",
    week: "week",
    weeks: "weeks",
    month: "month",
    months: "months",
    year: "year",
    years: "years",
  },
  mint: "Mint",
  type: "Type",
  new: "New",
  updateVersion: "There is an update available, would you like to update?",
  other: "Other",
  totalDistributed: "Total distributed",
  dailyDistributed: "Today is distributed:",
  transactions: {
    title: "Transactions",
    noTransactions: "No transactions",
    errorMessage: "The transaction could not be completed. Check the address or the balance of available tokens.",
    seeTransaction: "See transaction",
    types: {
      [TransactionType.MINT_POAP]: "Mint POAP",
    },
    status: {
      PENDING: "Pending",
      SUCCESS: "Success",
      REVERTED: "Reverted",
    },
  },
  signature: {
    title: "Signature",
    errorMessage: "The transaction could not be signed. Check the address or the balance of available tokens.",
    status: {
      PENDING: "Pending",
      SUCCESS: "Success",
      REVERTED: "Reverted",
    },
  },
  viewContract: "View contract",
  viewInExplorer: "View in explorer",
  view: "View",
  disconnect: "Disconnect",
  address: "Address",
  network: "Network",
  sendToSupport: "Send to Support",
  footer: {
    documentation: "Documentation",
    brandKit: "Brand Kit",
    legalDisclaimer: "Legal Disclaimer",
  },
}
